module.exports = __webpack_public_path__ + "static/banner-d410289aa6354410db32ec1a8d11b5ee.png";